import Cookies from 'js-cookie'
import { Toast } from "vant";
const TokenKey = 'vue_admin_template_token'
// 调用app接口封装
let AUTH = window.auth || {};
//测试
// const appId = "njsrmzfwsbgs_lxszglgj";
//正式
const appId = "njsrcfwzx_djwxtzq";
//获取用户信息
var getUserInfoByToken = (accessToken, afterFun) => {
  if (!accessToken) return;
  const data = JSON.stringify({ appId, accessToken });
  AUTH.getUserInfoByToken(data);
  window.getUserInfoByTokenCallback = (params) => {
    let res = JSON.parse(params); //jsonStr 转jsonObject
    if (res.success) {
      // var data = res.data; //用户信息密文

     afterFun && afterFun(res);
    } else {
      Toast("获取用户授权信息失败，原因：" + res.msg);
    }
  };
};

//获取token
const getAcssessToken = (afterFun) => {
  if (!AUTH.getAccessToken) return;
  let data = {
    appId,
    needStuInfo: "1",
    // effectiveCount: 600,
  };
  AUTH.getAccessToken(JSON.stringify(data));
  //不用做 callback 校验
  window.getAccessTokenCallback = (params) => {
    const data = JSON.parse(params);
    if (data.success) {
      var accessToken = data.data.accessToken;
      sessionStorage.setItem("accessToken", accessToken);
      //token改变 用户信息也改变
      getUserInfoByToken(accessToken, afterFun);
    } else {
      Toast("获取accessToken失败，原因：" + data.msg);
    }
  };
};

const getUserInfoAPP = (fun) => {
  if (!window.auth){
    Toast("无法在浏览器内登录");
    return
  }
  //AcssessToken 失效 无回掉，因此失效之后直接重新获取登录
  getAcssessToken(fun)
};

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export default {
  getAcssessToken,
  getUserInfoByToken,
  getUserInfoAPP,
};



// WEBPACK FOOTER //
// ./src/utils/authWX.js